var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-row',{staticClass:"row group-scoring__container-edit"},[_c('b-col',{attrs:{"cols":"6"}},[_c('span',{staticClass:"color-white fs-14"},[_vm._v(_vm._s(_vm.question.title))])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }